import template from './companies-update.html';
import controller from './companies-update.controller';
import './companies-update.styl'

const companiesUpdateComponent = {
  template,
  controller,
  controllerAs: 'companiesUpdate',
  require:{
    app: '^^app'
  }
};

export default companiesUpdateComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies-update/companies-update.component.js
 **/